import { css } from "@emotion/css";
import { mergeProps } from "react-aria";
import { Cell as AriaCell, CellProps } from "react-aria-components";

import { getTextStyle } from "../../../foundations/typography/styles";
import { textAlignment } from "../../data-tables/assets/Cell";
interface Props extends CellProps {
  textAlignment?: textAlignment;
}

export function DataCell(props: Props) {
  const styles = getStyles(props.textAlignment || "left");
  return (
    <AriaCell
      {...mergeProps(props, {
        className: css(styles.cell),
      })}
    />
  );
}

function getStyles(textAlignment: textAlignment) {
  return {
    cell: css(getTextStyle("global/body-primary"), {
      paddingTop: "var(--space-2-5)",
      paddingBottom: "var(--space-2-5)",
      paddingLeft: 0,
      paddingRight: "var(--space-5)",
      outline: "none",
      verticalAlign: "top",
      textAlign: textAlignment,
    }),
  };
}
